import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-add-new-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './add-new-button.html',
  styleUrl: './add-new-button.scss'
})
export class AddNewButton {
  @Input() text: string = 'Új elem';
  @Input() icon: string = 'add';
  @Input() color: 'primary' | 'accent' | 'warn' | undefined = 'primary';
  @Input() disabled: boolean = false;
  @Input() tooltip: string = '';
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'above';
  @Output() clicked = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}